import banner_1 from "src/assets/images/banner/banner_1.png";
import banner_2 from "src/assets/images/banner/banner_2.png";
import banner_3 from "src/assets/images/banner/banner_3.png";
import { ISlide } from "./types";

const getSubTitle = (subTitle: string) =>
  `<br /> <span class="font-spaceland text-96 xl:text-170 2xl:text-220 leading-0.9">${subTitle}</span>`;

export const SLIEDS: ISlide[] = [
  {
    id: 1,
    title: `Документи без стресу - ${getSubTitle("бізнес з успіхом.")}`,
    image: banner_1,
    text: "Консалтингова компанія «Універсальний бізнес ресурс» є провідним консультаційним центром з питань бухгалтерського обліку, оподаткування, проектного менеджменту та кадрового діловодства.",
    buttonLabel: "Послуги",
  },
  {
    id: 2,
    title: `Ми створюємо прості рішення<br /> для складних викликів ${getSubTitle(
      "вашого бізнесу."
    )}`,
    image: banner_2,
    text: "Наша компанія пропонує різноманітні пакети послуг для юридичних осіб та ФОП, враховуючи специфіку та потреби кожного клієнта. Ми розробили рішення різного обсягу: від базових консультацій до комплексного супроводу бізнесу.",
    buttonLabel: "Пакети",
  },
  {
    id: 3,
    title: `Ми спрощуємо складне - ${getSubTitle(
      "ви досягаєте<br /> більшого."
    )}`,
    image: banner_3,
    text: "Ми об’єднали в команду відповідальних кваліфікованих спеціалістів у своїй галузі, професіоналів, які працюють розумно й ефективно, систематично вдосконалюють свої знання та навички, шукають нові, ефективні рішення.",
    buttonLabel: "Команда",
  },
];
